import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";
function InstantPicking_Breadcrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/InstantPicking" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            InstantPicking{" "}
          </span>
        </div>
      ) : vPathName === "/InstantPickingDetail" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/InstantPicking"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            InstantPicking
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1px" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              InstantPickingDetail{" "}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default InstantPicking_Breadcrumbs;
